import { CommonModule } from '@angular/common';
import { Component, Output, EventEmitter } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { AuthServiceService } from '../services/auth-service.service';
import { UserService } from '../services/user.service';
import { LoadingModalComponent } from "../../../loading-modal/loading-modal.component";

export interface IConfiguracaoUsuario {
  quantidadedecanais: number;
  quantidadeMensagem: number;
  quantidadeNutricao: number,
  basicoMenu: boolean,
  agendaMenu: boolean,
  clinicorpMenu: boolean,
  ekuroMenu: boolean
}


@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [MatIconModule, CommonModule, RouterModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  providers: [UserService]
})
export class SidebarComponent {

  //Evento para informar qual item do menu esta selecionado
  @Output() selectedItem = new EventEmitter<string>();

  //Evento para informar que o menu esta aberto ou fechado
  @Output() menuStatus = new EventEmitter<boolean>();

  public version!: string;
  public menuSelected!: string;

  public menuUser: string = atob(localStorage.getItem('uL') ?? '');

  public acessoMenuUsuario!: IConfiguracaoUsuario;


  constructor(private router: Router, private authService: AuthServiceService, private userService: UserService) { }

  ngOnInit() {
    this.userService.getVersion().subscribe((response: any) => {
      console.log(response);
      this.version = response.version
    });

    this.userService.getConfigUser().subscribe((response: any) => {
      this.acessoMenuUsuario = response.configUser;

      if(this.acessoMenuUsuario.basicoMenu) {
        this.menuSelected = 'disparos';
      } else if(this.acessoMenuUsuario.agendaMenu) {
        this.menuSelected = 'agendas';
      } else if(this.acessoMenuUsuario.clinicorpMenu) {
        this.menuSelected = 'clinicorp-menu';
      }
    });
  }


  public async redirect(rota: string) {
    try {
      await this.router.navigate([rota]);
    } catch (error) {
      console.error('Erro ao redirecionar:', error);
    }
  }

  public itemSelected(item: string) {
    this.menuSelected = item;
    this.selectedItem.emit(item);
  }

  public menuOpen() {

    this.menuStatus.emit(true);
  }

  public menuClose() {

    this.menuStatus.emit(false);
  }

  public logout() {
    this.authService.logout();
  }
}
